"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var cart_1 = require("../../utils/cart");
var ga_1 = require("../../utils/ga");
var UpgradeToTwoBottleOneTime = function (_a) {
    var _b;
    var twoBottleProduct = _a.twoBottleProduct;
    var _c = (0, hooks_1.useContext)(CartContext_1.default), cart = _c.cart, renderCart = _c.renderCart;
    if (!twoBottleProduct) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var replacedCartItem = cart.items.find(function (cartItem) { return cartItem.handle === twoBottleProduct.handle.slice(0, -3); });
    var handleUpdateQuantity = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, (0, cart_1.updateCart)(event, replacedCartItem)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, renderCart()];
                case 3:
                    _a.sent();
                    (0, ga_1.sendEventAddToCart)(twoBottleProduct, twoBottleProduct.variants.nodes[0], ga_1.GaMethodValue.cartUpsell);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Error updating cart quantity:', error_1);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var brandName = twoBottleProduct.title.split(' ')[0];
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "cart-section__review-upsell" },
            (0, preact_1.h)("div", { class: "cart-section__review-upsell-item meno" },
                (0, preact_1.h)("img", { class: "cart-section__review-upsell-item-image", src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/Flash-Sale-Sticker.png?v=1729210575", alt: "alert" }),
                (0, preact_1.h)("div", { class: "cart-section__review-upsell-item-info" },
                    (0, preact_1.h)("p", { class: "cart-section__review-upsell-item-eyebrow" }, "LIMITED TIME OFFER"),
                    (0, preact_1.h)("p", { class: "cart-section__review-upsell-item-header" }, "Add a Bottle, Save $10"),
                    (0, preact_1.h)("p", { class: "cart-section__review-upsell-item-subheader" }, "".concat(brandName, " works best with consistent use")),
                    (0, preact_1.h)("form", { action: "/cart/add", class: "trigger--cart trigger--replace", "data-replace-item": replacedCartItem === null || replacedCartItem === void 0 ? void 0 : replacedCartItem.id, method: "POST", onSubmit: function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, handleUpdateQuantity(event)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); } },
                        (0, preact_1.h)("input", { type: "hidden", name: "form_type", value: "product" }),
                        (0, preact_1.h)("input", { type: "hidden", name: "utf8", value: "\u2713" }),
                        (0, preact_1.h)("input", { type: "hidden", name: "quantity", value: "1" }),
                        (0, preact_1.h)("input", { type: "hidden", name: "id", value: Number((_b = twoBottleProduct.variants.nodes[0]) === null || _b === void 0 ? void 0 : _b.id.split('/')[4]) }),
                        (0, preact_1.h)("div", { class: "cart-section__review-upsell-item-button" },
                            (0, preact_1.h)("button", { class: " button button--hot-orange", type: "submit" }, "APPLY OFFER"))))))));
};
exports.default = UpgradeToTwoBottleOneTime;
